import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AppAuthenticationService } from './app.authentication';


@Injectable()
export class AdminAuthGuardService implements CanActivate {

  constructor(private router: Router, private authService: AppAuthenticationService) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

    if (this.authService.isUserAdmin()) {
      return true;
    } else {
      this.router.navigate(['/Home'], {
        queryParams: {
          return: state.url
        }
      });
      return false;
    }
  }
}
